module.exports = __webpack_public_path__ + "static/img/content_4.9cf2512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qiwei/content_4.png
// module id = Of1V
// module chunks = 94